module.exports = __webpack_public_path__ + "img/moonpay-logo.ac396b59.svg";